<p-fileUpload
  accept="image/*"
  [maxFileSize]="2000000"
  name="certificate-uploader"
  url="https://www.primefaces.org/cdn/api/upload.php"
  method="post"
  chooseLabel="Selecionar"
  uploadLabel="Enviar"
  [showCancelButton]="false"
  invalidFileTypeMessageDetail="deve ser .p12 ou .pfx"
  invalidFileTypeMessageSummary="Arquivo inválido, "
  invalidFileSizeMessageSummary="Arquivo é muito grande, "
  invalidFileSizeMessageDetail="deve conter até 2mb"
  [customUpload]="true"
  (onSelect)="selectFile($event)"
  accept=".pfx,.p12"
  [showUploadButton]="false"
>
  <ng-template pTemplate="toolbar">
    <form [formGroup]="certificateForm">
      <app-fields *ngIf="hasFile">
        <app-input
          formControlName="senha"
          type="password"
          label="Senha do certificado"
        ></app-input>
      </app-fields>
    </form>
  </ng-template>
  <ng-template let-file pTemplate="file">
    <div class="file">
      <span class="pi pi-file"></span>
      <span> {{ file.name }} - {{ file.size | number }}kb </span>
    </div>
  </ng-template>
</p-fileUpload>
